import React, { useEffect, useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { ImCross } from "react-icons/im";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { useHistory, useParams } from "react-router";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import TablePagination from "../../../../components/TablePagination";

export const OcorrenciasTable = ({
  data,
  columns,
  setIsTrueVisualizar,
  roleKeycloack,
  entidade,
  deleteOcorrencia,
  setInitialValues,
  disableHeaderOptions,
  idPJ,
  user,
}) => {
  const { onClose } = useDisclosure();
  const history = useHistory();
  const [nItens, setNItens] = useState(10);
  const { id } = useParams();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    gotoPage,
    pageOptions,
    page,
    canPreviousPage,
    previousPage,
    canNextPage,
    nextPage,
    pageCount,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        pageSize: nItens,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      !disableHeaderOptions &&
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            id: "moreInfo",
            Header: "Opções",
            Cell: ({ row }) => {
              const showItens =
                roleKeycloack &&
                (roleKeycloack.includes(ocorrenciasFunc.alterar) ||
                  roleKeycloack.includes(ocorrenciasFunc.excluir) ||
                  ((roleKeycloack?.includes(
                    criancaFunc.visualizarTudoAcolhimento
                  ) ||
                    roleKeycloack?.includes(
                      criancaFunc.visualizarTudoTutelar
                    ) ||
                    roleKeycloack?.includes(
                      servicoAcolhimentoFunc.visualizarPartePPCAAM
                    )) &&
                    user?.orgaoExternoOriginal?.includes(
                      Number(row?.original?.idOrgaoExterno)
                    )) ||
                  ((roleKeycloack?.includes(
                    servicoAcolhimentoFunc.visualizarParteTJ
                  ) ||
                    roleKeycloack?.includes(
                      servicoAcolhimentoFunc.visualizarParteMP
                    )) &&
                    (user?.orgaoExterno?.includes(
                      Number(
                        row?.original?.idOrgaoExterno || row?.original?.idOrgao
                      )
                    ) ||
                      (user.orgaos &&
                        user.orgaos[0]?.id === row?.original?.idOrgao))));

              return (
                <Flex justifyContent="center">
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      icon={<BsThreeDots color="#fff" fontSize="20px" />}
                      variant={"link"}
                      cursor={"pointer"}
                      backgroundColor="#95BCBF"
                      rounded={100}
                      p={2}
                    />
                    {showItens ? (
                      <MenuList>
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={ocorrenciasFunc.alterar}
                          user={user}
                          id={idPJ}
                          visualizar={true}
                          mpTJ={true}
                          idMPTJ={
                            row?.original?.idOrgaoExterno ||
                            row?.original?.idOrgao
                          }
                          ppcaam={true}
                        >
                          <MenuItem
                            p={2}
                            color={"#374BCE"}
                            onClick={() => {
                              history.push(
                                `/crianca/editar-ocorrencias/${id}/${
                                  (row?.original?.idOrgaoExterno &&
                                    row?.original?.idOrgaoExterno) ||
                                  (row?.original?.idOrgao &&
                                    row?.original?.idOrgao)
                                } `
                              );

                              const date = new Date(
                                row.original.dataOcorrencia
                              );
                              const day = String(date.getDate()).padStart(
                                2,
                                "0"
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, "0");
                              const year = date.getFullYear();
                              const formattedDate = `${day}/${month}/${year}`;

                              setInitialValues({
                                idOcorrencia: row.original.idOcorrencia,
                                dataOcorrencia: formattedDate,
                                descricaoOcorrencia: row.original
                                  .descricaoOcorrencia
                                  ? row.original.descricaoOcorrencia
                                  : "",
                                tipoOcorrencia: row.original.tipoOcorrencia,
                                justificativaOcorrencia: row.original
                                  .justificativaOcorrencia
                                  ? row.original.justificativaOcorrencia
                                  : "",
                              });

                              setIsTrueVisualizar(false);
                            }}
                          >
                            <FiEdit />
                            <Text ml="5px">Editar</Text>
                          </MenuItem>
                        </Permission>
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={ocorrenciasFunc.excluir}
                          user={user}
                          id={idPJ}
                          visualizar={true}
                          mpTJ={true}
                          idMPTJ={
                            row?.original?.idOrgaoExterno ||
                            row?.original?.idOrgao
                          }
                          ppcaam={true}
                        >
                          <MenuItem
                            p={2}
                            color={"red.500"}
                            onClick={() => {
                              deleteOcorrencia(
                                row.original.idOcorrencia,
                                onClose
                              );
                            }}
                          >
                            <ImCross />
                            <Text ml="5px">Excluir</Text>
                          </MenuItem>
                        </Permission>
                      </MenuList>
                    ) : (
                      ""
                    )}
                  </Menu>
                </Flex>
              );
            },
          },
        ]);
    }
  );

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-count")) {
      setNItens(
        parseInt(sessionStorage.getItem(entidade + "-pagination-count"))
      );
    }
  }, [entidade]);

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-page")) {
      const tempPage = Number(
        sessionStorage.getItem(entidade + "-pagination-page")
      );
      if (tempPage <= pageCount) {
        gotoPage(tempPage);
      }
    }
  }, [state, entidade, gotoPage, pageCount]);

  function irParaPagina(pagina) {
    sessionStorage.setItem(entidade + "-pagination-page", pagina);
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);
    setPageSize(nItens);
  }

  return (
    <Flex flexDir="column" overflowX="auto">
      <Table {...getTableProps} backgroundColor="white" mt="5px">
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps({
                    ...column.getHeaderProps(
                      !(column.Header === "Opções") &&
                        column.getSortByToggleProps({ title: undefined })
                    ),
                  })}
                  key={index}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ? "center" : "flex-start"
                    }
                  >
                    <Text as="p" whiteSpace={"nowrap"}>
                      {column.render("Header")}
                    </Text>

                    {column.Header !== "Opções" ? (
                      <Flex pl={1} alignItems="center">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon as={FaSortDown} boxSize="14px" />
                          ) : (
                            <Icon as={FaSortUp} boxSize="14px" />
                          )
                        ) : (
                          <Icon as={FaSort} boxSize="14px" />
                        )}
                      </Flex>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr width={"10%"} {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <Td
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      textAlign={
                        cell.column.Header === "Descrição/Justificativa" &&
                        "justify"
                      }
                      lineHeight="21.6px"
                      borderBottom={"solid"}
                      color="#797A80"
                      maxW={
                        cell.column.Header === "Descrição/Justificativa" && 450
                      }
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {!disableHeaderOptions && (
        <TablePagination
          nItens={nItens}
          selecionarTotalItens={selecionarTotalItens}
          irParaPagina={irParaPagina}
          pageSize={state.pageSize}
          setPageSize={setPageSize}
          rows={rows}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          pageOptions={pageOptions}
          pageIndex={state.pageIndex}
          canNextPage={canNextPage}
          nextPage={nextPage}
          pageCount={pageCount}
        />
      )}
    </Flex>
  );
};
